import {
    Dropdown,
    DropdownItem,
    DropdownMenu,
    DropdownToggle
} from "reactstrap";
import React, { useContext, useState } from "react";
import { getItemFromStore, getStatusBadge } from "@src/utility/helpers/utils";

import Avatar from "@src/@core/components/ui-components/avatar";
import { ComponentSpinner } from "@src/@core/components/spinner";
import Flex from "@src/@core/components/ui-components/flex";
import LongNameFormatter from "@src/@core/components/formatters/long-name-formatter";
import { ProductContext } from "@src/utility/context/product";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const PlatformListDropdown = () => {

    const [dropdownOpen, setDropdownOpen] = useState(false);
    const { t } = useTranslation();
    const navigate = useNavigate();
    const menuCollapsed = getItemFromStore("menuCollapsed");
    const {
        productList: platforms = [],
        selectedProduct,
        platformId,
        handleProductSelect
    } = useContext(ProductContext);

    const toggle = () => setDropdownOpen((prev) => !prev);

    const selectedPlatform =
        platforms.find((p) => p._id === platformId) || selectedProduct;

    const handlePlatformSelect = (platform) => {
        handleProductSelect(platform);
        navigate(`/dashboard/${platform._id}`);

    };

    if (!platforms) {
        return (
            <div className="mb-3 px-3">
                <ComponentSpinner />
            </div>
        );
    }

    return (
        <div className={`my-2 ${menuCollapsed ? "px-25" : "px-1"}`}>
            <Dropdown
                isOpen={dropdownOpen}
                toggle={toggle}
                className="w-100">
                <DropdownToggle
                    caret
                    className="w-100 d-flex align-items-center bg-transparent justify-content-between card-task border-0 text-start pe-1 menu-dropdown-toggle">
                    <Flex align="center" className="flex-grow-1">
                        <Avatar
                            color={getStatusBadge(selectedPlatform?.name).color}
                            img={false}
                            content={selectedPlatform?.name}
                            initials
                            size="sm" />
                        <LongNameFormatter
                            content={selectedPlatform?.name}
                            className="fw-bold fs-4 text-uppercase text-primary mb-0 hide-dropdown-toggle"
                            max={20} />
                    </Flex>
                </DropdownToggle>

                <DropdownMenu
                    className="w-100 shadow-lg bg-light border-0 p-0"
                    style={{ maxHeight: 320, overflowY: "auto", minWidth: 220  }}>
                    <div
                        className="sticky-top bg-light border-bottom zindex-2">
                        <DropdownItem
                            header
                            className="text-uppercase fw-bold text-muted fs-6 py-1 bg-light border-bottom">
                            {t("Products")} ({platforms.length})
                        </DropdownItem>
                        <DropdownItem divider className="m-0" />
                    </div>
                    <div className="overflow-auto" style={{ maxHeight: 220 }}>
                        {platforms.map((platform) => (
                            <DropdownItem
                                key={platform._id}
                                onClick={() => handlePlatformSelect(platform)}
                                className={
                                    selectedPlatform?._id === platform._id ? "active" : ""
                                }>
                                <Flex align="center">
                                    <Avatar
                                        color={getStatusBadge(platform.name).color}
                                        img={false}
                                        content={platform.name}
                                        initials
                                        size="sm" />
                                    <LongNameFormatter
                                        content={platform.name}
                                        className="fw-bold"
                                        max={25} />
                                </Flex>
                            </DropdownItem>
                        ))}
                    </div>
                    <div
                        className="sticky-bottom bg-light border-top zindex-2">
                        <DropdownItem divider className="m-0" />
                        <DropdownItem
                            onClick={() => navigate("/platforms")}
                            className="text-center fw-bold bg-light border-top">
                            <i className="mdi mdi-plus me-1"></i>
                            {t("Manage Products")}
                        </DropdownItem>
                    </div>
                </DropdownMenu>
            </Dropdown>
        </div>
    );
};

export default PlatformListDropdown;
